export const PRODUCT_RECOMMENDED_PRODUCTS_VALUE_ALL = 'all';

export const PRODUCT_CARD_IMAGE_BASE_WIDTH = 250;
export const PRODUCT_CARD_IMAGE_BASE_HEIGHT = 187;
export const PRODUCT_CARD_IMAGE_RECOMMENDATION_WIDTH = 371;
export const PRODUCT_CARD_IMAGE_RECOMMENDATION_HEIGHT = 278;
